import { render, staticRenderFns } from "./DialogUpgrade.vue?vue&type=template&id=0ad489df&scoped=true"
import script from "./DialogUpgrade.vue?vue&type=script&lang=js"
export * from "./DialogUpgrade.vue?vue&type=script&lang=js"
import style0 from "./DialogUpgrade.vue?vue&type=style&index=0&id=0ad489df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad489df",
  null
  
)

export default component.exports